import { formatCuitDisplay, type CuitResponse } from "@repo/shared";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type CuitEnvironment = CuitResponse["environment"];

const ENVIRONMENT_META: Record<
  CuitEnvironment,
  { label: string; variant: "pending" | "success" }
> = {
  homologacion: {
    label: "HOMOLOGACIÓN",
    variant: "pending",
  },
  produccion: {
    label: "PRODUCCIÓN",
    variant: "success",
  },
};

interface CuitEnvironmentBadgeProps {
  environment: CuitEnvironment;
  className?: string;
}

function CuitEnvironmentBadge({ environment, className }: CuitEnvironmentBadgeProps) {
  const meta = ENVIRONMENT_META[environment];

  return (
    <Badge
      variant={meta.variant}
      className={cn("px-2 py-1 text-[0.62rem] leading-none whitespace-nowrap", className)}
    >
      {meta.label}
    </Badge>
  );
}

interface ActiveCuitIdentityProps {
  cuit: CuitResponse;
  className?: string;
}

function ActiveCuitIdentity({ cuit, className }: ActiveCuitIdentityProps) {
  return (
    <div className={cn("mt-2 flex flex-wrap items-center gap-2 text-lg font-bold text-black", className)}>
      <span className="max-w-full truncate">{cuit.razonSocial}</span>
      <span className="font-mono text-sm tracking-widest text-[var(--ink-secondary)]">
        [{formatCuitDisplay(cuit.cuit)}]
      </span>
      <CuitEnvironmentBadge environment={cuit.environment} />
    </div>
  );
}

export { ActiveCuitIdentity, CuitEnvironmentBadge };
